import { Link } from '@vgw/multibrand-fe-link'
import { Trans, useLingui } from '@lingui/react/macro'
import { getBrandConfig } from '@/config/config'

export const Disclaimer = () => {
  const { t } = useLingui()

  const { pamLegalDocumentsUrl } = getBrandConfig()
  const { ageRestriction } = getBrandConfig()

  return (
    <p
      className="text-xs font-bold text-content lg:text-center"
      title="Disclaimer"
    >
      <Trans>
        No purchase necessary. VGW Group. Void where prohibited by law. See{' '}
        <Link
          size="xs"
          weight="bold"
          href={`${pamLegalDocumentsUrl}/terms-and-conditions`}
          target="_blank"
          rel="noopener"
          aria-label={t`Read Terms & Conditions to learn more`}
          title={t`Read Terms & Conditions to learn more`}
        >
          T&Cs
        </Link>
        . {ageRestriction}+. For detailed rules, see{' '}
        <Link
          size="xs"
          weight="bold"
          href={`${pamLegalDocumentsUrl}/sweeps-rules`}
          target="_blank"
          rel="noopener"
          aria-label={t`Read Sweeps Rules to learn more`}
          title={t`Read Sweeps Rules to learn more`}
        >
          Sweeps Rules
        </Link>
        .
      </Trans>
    </p>
  )
}
